var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { toRound } from 'helpers/Format';
import history from 'helpers/History';
import Theme from 'Theme';
import { Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
let TicketCashDeskDetail = class TicketCashDeskDetail extends Component {
    constructor() {
        super(...arguments);
        this.findUser = (lista, id) => {
            const result = lista.find(value => value.id === id);
            return result ? result.name : '';
        };
        this.handleOnSelectItem = (item) => {
            console.error(item.id);
        };
        this.toggle = () => {
            this.props.store.cashDeskTicketStore.close();
            this.props.store.users.logout();
            // history.goBack()
        };
    }
    UNSAFE_componentWillMount() {
        console.log('UNSAFE_componentWillMount');
        if (history.location.state === undefined) {
            history.goBack();
        }
    }
    componentDidMount() {
        console.log('TicketGratis - componentDidMount');
        this.props.store.reports.readTicketGratis();
    }
    render() {
        const item = history.location.state;
        console.log('item: ', item);
        const ticketPrinted = typeof item.refundTickets === 'string' ? JSON.parse(item.printedTickets).printed : item.printedTickets.printed;
        const ticketRefunded = typeof item.refundTickets === 'string' ? JSON.parse(item.refundTickets).refunded : item.refundTickets.refunded;
        const { reports } = this.props.store;
        const items = reports.ticketGratis;
        const image = `${process.env.REACT_APP_SERVER}${item.image}`;
        const externalCloseBtn = React.createElement("button", { className: "close", style: { color: Theme.color.primary, position: 'absolute', top: '50px', right: '15px' }, onClick: this.toggle }, "\u00D7");
        return (React.createElement("div", { className: "animated fadeIn" },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Modal, { centered: true, fade: true, isOpen: true, modalTransition: { timeout: 700 }, backdropTransition: { timeout: 1000 }, toggle: this.toggle, 
                        /*external={externalCloseBtn}*/
                        style: { width: '320px' } },
                        React.createElement(ModalHeader, null, `Cierre de caja`),
                        React.createElement(ModalBody, null,
                            React.createElement("p", { style: {
                                    marginBottom: '5px',
                                    width: '100%',
                                    height: '1px',
                                    background: 'black',
                                } }, ''),
                            React.createElement("div", { style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                } },
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'Apertura: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, ` ${item.dateOpen}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'Cierre: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, ` ${item.dateClose}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'Operario:'),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, ` ${item.username}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'Dispositivo: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, ` ${item.terminalBrand}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-end'
                                    } },
                                    React.createElement("p", { style: { marginLeft: '10px', fontWeight: 'bold' } }, ` ${item.terminalSN}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'TOTAL: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, ` ${toRound(item.total)}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'TOTAL EFECTIVO: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, ` ${item.totalCash}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'TOTAL TARJETA: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, ` ${item.totalCard}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'DESCUENTO: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, ` ${item.totalDiscount}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'CHECKINS: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, ` ${item.checkins}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'TICKETS: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, ` ${ticketPrinted.length}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { marginBottom: 0, fontWeight: 'bold' } }, 'DEVOLUCIONES: '),
                                    React.createElement("p", { style: { marginBottom: 0, marginLeft: '10px' } }, ` ${ticketRefunded.length}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { fontWeight: 'bold' } }, 'TOTAL ABONADO: '),
                                    React.createElement("p", { style: { marginLeft: '10px' } }, ` ${item.totalRefund}`)),
                                React.createElement("div", { style: {
                                        width: '275px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    } },
                                    React.createElement("p", { style: { fontWeight: 'bold' } }, 'LISTA DE VENTAS')),
                                item.lines.map(line => React.createElement("div", { key: line.id, style: { display: 'flex', flexDirection: 'column' } },
                                    React.createElement("div", { style: {
                                            width: '275px',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'flex-start'
                                        } },
                                        React.createElement("p", { style: { marginBottom: 0, } }, `${line.quantity}x`),
                                        React.createElement("p", { style: { marginBottom: 0, marginLeft: '5px' } }, line.passengerCategory)),
                                    React.createElement("div", { style: {
                                            width: '275px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center'
                                        } },
                                        React.createElement("p", { style: { marginBottom: 0, textAlign: 'center' } }, line.operationLine),
                                        React.createElement("p", { style: { marginBottom: 0, textAlign: 'center' } }, line.stretch)),
                                    line.totalDiscount > 0 && React.createElement("div", { style: {
                                            width: '275px',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'flex-end'
                                        } },
                                        React.createElement("p", { style: { marginBottom: 0, textAlign: 'end', width: '200px' } }, `Descuento: ${line.totalDiscount} ${line.money || 'EUR'}`)),
                                    React.createElement("div", { style: {
                                            width: '275px',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'flex-end'
                                        } },
                                        React.createElement("p", { style: { textAlign: 'end', width: '100px' } }, `Total: ${toRound(line.total)} ${line.money || 'EUR'}`)))),
                                React.createElement("p", { style: {
                                        marginBottom: '5px',
                                        width: '100%',
                                        height: '1px',
                                        background: 'black',
                                    } }, ''))))))));
    }
};
TicketCashDeskDetail = __decorate([
    inject('store'),
    observer
], TicketCashDeskDetail);
export default TicketCashDeskDetail;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/TicketCashDeskDetail.tsx
// module id = 536
// module chunks = 0